<template>
    <div>
        <Header/>
        <section class="ftco-section">
            <div class="container-fluid d-flex justify-content-center">
                <div class="row container">
                  <div class="row d-flex justify-content-between col-12">
                    <div class="col-sm-4">
                      <div class="card" style="border-color: #0b5d6f; border-width: 3px; border-radius: 20px;">
                        <div class="card-body">
                          <h5 class="card-title text-info">SO Approval</h5>
                          <p class="card-text text-info">Pengisian SO Approval</p>
                          <a href="/recom" class="btn btn-primary d-flex align-items-center justify-content-center">Selengkapnya</a>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="card" style="border-color: #0b5d6f; border-width: 3px; border-radius: 20px;">
                        <div class="card-body">
                          <h5 class="card-title text-info">Transit</h5>
                          <p class="card-text text-info">Pengecekan Transit</p>
                          <a href="/transit" class="btn btn-primary d-flex align-items-center justify-content-center">Selengkapnya</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
            </div>
        </section>
    </div>
</template>
<script lang="ts" src="./Home.ts"></script>